import { useSelector } from 'react-redux';

const DEFAULT_PREFS = {
  enabled: true,
  sources: { org: true, global: true },
  surfaces: { reports: true, liveMap: true, replay: true, notifications: false },
};

function deepMerge(base, override) {
  if (override == null) return base;
  if (typeof override !== 'object' || Array.isArray(override)) return override;
  const result = { ...base };
  for (const key of Object.keys(override)) {
    result[key] = deepMerge(base?.[key], override[key]);
  }
  return result;
}

export function usePoiLabelPrefs() {
  const orgSettings = useSelector((s) => s.org?.settings);
  const userAttrs = useSelector((s) => s.session?.user?.attributes);
  const orgOverride = orgSettings?.poiLabels;
  const userOverride = userAttrs?.poiLabels;
  return deepMerge(deepMerge(DEFAULT_PREFS, orgOverride), userOverride);
}
